module.exports = __webpack_public_path__ + "static/media/estrutura-quem-somos.5f1e5fe4.svg";